import { useAppSelector } from '../buildStore';
export const getWidgetSize = state => {
  return state.widgetSize.size;
};
export const useWidgetSize = () => {
  return useAppSelector(getWidgetSize);
};